var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-pop", {
    attrs: {
      opened: _vm.opendAcnoInfoReg,
      modalHeader: true,
      modalFooter: true,
      title: "MPAY-02-01-28-17"
    },
    on: {
      "update:opened": function($event) {
        _vm.opendAcnoInfoReg = $event
      }
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              [
                _vm.lang == _vm.$config.LANG_KOR
                  ? [
                      _vm._v(
                        _vm._s(
                          /*예금주명이 등록된 계좌만 타행 이체 거래 가능합니다.*/ _vm.$t(
                            "MPAY-02-01-28-16"
                          )
                        )
                      )
                    ]
                  : [
                      _c("strong", { staticClass: "text-info-left" }, [
                        _vm._v(
                          _vm._s(
                            /*예금주명이 등록된 계좌만 타행 이체 거래 가능합니다.*/ _vm.$t(
                              "MPAY-02-01-28-16"
                            )
                          )
                        )
                      ])
                    ]
              ],
              2
            ),
            _c("div", [
              _vm._v(
                _vm._s(
                  /*예금주명이 등록된 계좌만 타행 이체 거래 가능합니다.*/ _vm.$t(
                    "MPAY-02-01-28-19"
                  )
                )
              )
            ]),
            _c("div", { staticClass: "account-info -type9" }, [
              _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "tit" }, [
                  _vm._v(_vm._s(/* 입금은행 */ _vm.$t("MPAY-03-02-06-05")))
                ]),
                _c("div", { staticClass: "dec" }, [
                  _vm._v(_vm._s(_vm.mnrcvInfo.mnrcvOthrBnkName))
                ])
              ]),
              _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "tit" }, [
                  _vm._v(_vm._s(/*입금계좌번호*/ _vm.$t("MPAY-02-01-26-08")))
                ]),
                _c("div", { staticClass: "dec" }, [
                  _vm._v(_vm._s(_vm.mnrcvInfo.mnrcvAcno))
                ])
              ]),
              _c("div", { staticClass: "item" }, [
                _c("div", { staticClass: "tit" }, [
                  _vm._v(_vm._s(/*계좌 별명*/ _vm.$t("MPRS-02-01-03-05")))
                ]),
                _c("div", { staticClass: "dec" }, [
                  _vm._v(_vm._s(_vm.mnrcvInfo.mnrcvAcnAls))
                ])
              ])
            ]),
            _c(
              "div",
              { staticClass: "form" },
              [
                _c("input-text", {
                  ref: "mnrcvDpstrName",
                  attrs: {
                    id: "mnrcvDpstrName",
                    value: _vm.changeData.mnrcvDpstrName,
                    labelI18n: "MPRS-02-02-19-05",
                    placeholder: "MPRS-02-02-19-06",
                    required: "",
                    localeCase3: "" + _vm.$config.SITECODE_OGHCM,
                    maxByte: 40
                  },
                  on: {
                    "update:value": function($event) {
                      return _vm.$set(_vm.changeData, "mnrcvDpstrName", $event)
                    }
                  }
                })
              ],
              1
            ),
            _c("strong", { staticClass: "info-question" }, [
              _vm._v(
                _vm._s(
                  /*위 예금주명으로 등록합니다.*/ _vm.$t("MPAY-02-01-28-18")
                )
              )
            ])
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "button",
              {
                class: [
                  "btn bottom positive",
                  _vm.changeData.mnrcvDpstrName == "" ? "disabled" : ""
                ],
                on: { click: _vm.updateAcnoInfo }
              },
              [_vm._v(_vm._s(/* 확인 */ _vm.$t("MCOM-0000003")))]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }